export interface RequestOpts {
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  url: string;
  body?: unknown;
  headers?: Record<string, string>;
}

export interface ResponseShape {
  status: number;
  body: unknown;
}

export type Adapter = (opts: RequestOpts) => Promise<ResponseShape>;

export const fetchAdapter: Adapter = async (opts) => {
  const hasBody = opts.body !== undefined && opts.body !== null;
  const r = await fetch(opts.url, {
    method: opts.method,
    headers: {
      ...(hasBody ? { 'content-type': 'application/json' } : {}),
      ...(opts.headers ?? {}),
    },
    body: hasBody ? JSON.stringify(opts.body) : undefined,
  });
  return { status: r.status, body: await r.json() };
};
